'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var DayElement = require('../components/DayElement/DayElement.js');
var ChevronLeftIcon = _interopDefault(require('@material-ui/icons/ChevronLeft'));
var ChevronRightIcon = _interopDefault(require('@material-ui/icons/ChevronRight'));
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var WeekPicker = function (props) {
    var week = props.week, updateWeek = props.updateWeek;
    var _a = React.useState(false), pickerOpen = _a[0], setPickerOpen = _a[1];
    var _b = React.useState(null), selectedDate = _b[0], setSelectedDate = _b[1];
    React.useEffect(function () {
        if (pickerOpen || !selectedDate) {
            return;
        }
        var d = selectedDate;
        var startOfWeek = utils.getWeekRange(d).startOfWeek;
        var sd = d.clone().startOf('day');
        updateWeek(startOfWeek, sd);
    }, [pickerOpen, selectedDate]);
    var backOneWeek = function () {
        var sd = week.clone().subtract(1, 'week');
        updateWeek(sd);
    };
    var forwardOneWeek = function () {
        var sd = week.clone().add(1, 'week');
        updateWeek(sd);
    };
    var handleOnChange = function (date) {
        setSelectedDate(date);
    };
    var handleOnAccept = function (date) {
        setSelectedDate(date);
    };
    var handleOnOpen = function () {
        setPickerOpen(true);
    };
    var handleOnClose = function () {
        setPickerOpen(false);
    };
    var text = utils.getWeekRange(week).text;
    return (React__default.createElement(styledComponents.Main, null,
        React__default.createElement(styledComponents.LeftChevronButton, { onClick: backOneWeek, "data-testid": 'left-chevron' },
            React__default.createElement(ChevronLeftIcon, null)),
        React__default.createElement(styledComponents.TextContainer, null,
            React__default.createElement(styledComponents.StyledKeyboardDatePicker, { variant: 'inline', value: week, autoOk: true, onChange: handleOnChange, onAccept: handleOnAccept, renderDay: DayElement, "data-testid": 'weekpicker-picker', inputProps: {
                    'data-testid': 'weekpicker-picker-input',
                }, keyboardIcon: React__default.createElement(styledComponents.StyledEventAvailableIcon, { "data-testid": 'weekpicker-picker-icon' }), views: ['year', 'month', 'date'], onOpen: handleOnOpen, onClose: handleOnClose, PopoverProps: {
                    transformOrigin: {
                        vertical: -20,
                        horizontal: 0,
                    },
                } }),
            React__default.createElement(styledComponents.TextWithOutline, { "data-testid": 'weekpicker-text' }, text)),
        React__default.createElement(styledComponents.RightChevronButton, { onClick: forwardOneWeek, "data-testid": 'right-chevron' },
            React__default.createElement(ChevronRightIcon, null))));
};

module.exports = WeekPicker;
